export default "__VITE_ASSET__CbfBS2l4__"